import type { PatchedAdminKnowledgeHintRequest } from '@/api/model'

/** Orval's form encoder omits empty arrays; PATCH must send [] to clear all placements. */
export function knowledgeHintFormData(values?: PatchedAdminKnowledgeHintRequest): FormData {
  const data = new FormData()
  for (const [key, value] of Object.entries(values ?? {})) {
    if (value === undefined) continue
    if (value instanceof Blob) data.append(key, value)
    else data.append(key, Array.isArray(value) ? JSON.stringify(value) : String(value))
  }
  return data
}
